"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInputContent = void 0;
exports.NumberInputContent = {
  en: {
    mustBeGreaterThan: "Must be %min% or larger",
    mustBeLessThan: "Must be %max% or smaller",
    invalidPattern: "May have no more than %precision% decimal places"
  },
  fr: {
    mustBeGreaterThan: "Doit être %min% ou plus",
    mustBeLessThan: "Doit êtr %max% ou moins",
    invalidPattern: "N’a peut-être pas plus de %precision% décimales"
  },
  es: {
    mustBeGreaterThan: "Debe ser %min% o mayor",
    mustBeLessThan: "El valor debe ser inferior al %max%",
    invalidPattern: "No puede tener más de %precision% decimales"
  }
};